<template>

  <v-toolbar       clipped-left fixed app  color="#273C51" height='42px'>

    <v-toolbar-side-icon   @click="$store.commit('leftNavOn','true')" class="white--text hidden-lg-and-up" > </v-toolbar-side-icon>







    <v-toolbar-items   class="hidden-sm-and-down  "   >
      <v-btn style="text-transform: none !important;" @click="changeContentType('parser')"  class="white--text"   flat> <v-icon dark left   >mdi-magnify</v-icon>    Парсер  </v-btn>
      <v-btn style="text-transform: none !important;" @click="changeContentType('activiti')" class="white--text" flat> <v-icon dark left   >mdi-radioactive</v-icon>     Активность   </v-btn>
      <v-btn style="text-transform: none !important;" @click="changeContentType('tasks')" class="white--text" flat><v-icon dark left   >mdi-calendar-check</v-icon> Действия</v-btn>
      <v-btn style="text-transform: none !important;" @click="changeContentType('proc')" class="white--text" flat><v-icon dark left   >mdi-react</v-icon> Инструменты</v-btn>
      <v-btn style="text-transform: none !important;" @click="changeContentType('resources')" class="white--text" flat><v-icon dark  left  >mdi-account-switch</v-icon> Аккаунты</v-btn>
    </v-toolbar-items>

    <v-toolbar-items   class="hidden-md-and-up"   >
     <div style="width:45px"></div>
     <v-icon @click="changeContentType('parser')" dark left   >mdi-magnify</v-icon>
     <v-icon @click="changeContentType('activiti')" dark left   >mdi-radioactive</v-icon>
     <v-icon @click="changeContentType('tasks')" dark left   >mdi-calendar-check</v-icon>
     <v-icon @click="changeContentType('proc')" dark left   >mdi-react</v-icon>
     <v-icon @click="changeContentType('resources')" dark  left  >mdi-account-switch</v-icon>
    </v-toolbar-items>

    <v-spacer> </v-spacer>

    <v-btn @click="changeContentType('auths')" icon class="white--text" small >
    <v-tooltip left><v-icon small slot="activator">mdi-server</v-icon>
    <p style="width:150px">Изменить текущий сервер или добавить новый</p>
    </v-tooltip>
    </v-btn>




  </v-toolbar>

</template>




<script>
 export default {
 data(){
   return  {
     upDateter:false
   }
 },
 methods : {
  changeContentType (categoryType){
     this.$vuetify.goTo(0)
     this.$store.commit('leftNavOn', true )
     this.$router.push('/'+categoryType)

     if(categoryType == 'resources'){
       //alert(666)
     }

  },


 }
 }
</script>





<style>

</style>
